import axios from "axios";
import commonActions, { SetWorkItemDetailData, SetWorkItemListData, SetDraftsListData, SetDTNDetailData, setGlobalSearchText, SetBallotHistoryData, setLoader, setminiLoader } from "../../common.actions";
import getApiUrl from "../../helpers/api-urls";
import { getApiUniqueRequestId, getMessage, removeLeadingZeroes } from "../../helpers/util-common";
import messages from '../../assets/i18n/en';
import { AuditLogTypeEnum, CollabApiFailureActionEnum } from "../../pages/WorkItemDetails/workItemDetail.model";
import * as _types from '../../action-type';

export const getWorkItemListAction :any =(dispatch: any,data:any, callback: any,)=>{
    dispatch(commonActions.setLoader(true));
    const encodedPayload = encodeURIComponent(JSON.stringify(data));
    let url = `${getApiUrl("documents", "getWorkItemList")}?payload=${encodedPayload}`;
    axios
      .get(url)
      .then((response) => {
        if (!response?.data?.status) {
          dispatch(commonActions.setOverlayLoader(false));
        }
        const uniqueRequestId = getApiUniqueRequestId(url);
        if (response.data.status) {
          callback(response.data.content);
          dispatch(SetWorkItemListData(response.data.content));
          dispatch(commonActions.setLoader(false));
        } else {
          // Handle error case
          dispatch(commonActions.setLoader(false));
          dispatch(SetWorkItemListData({hasError : true}));
          dispatch(commonActions.setMessage(true, response.data.message, uniqueRequestId));
        }
      })
      .catch((err) => {
        dispatch(commonActions.setOverlayLoader(false));        
        const uniqueRequestId = getApiUniqueRequestId(url);
        dispatch(commonActions.setLoader(false));
        dispatch(commonActions.setMessage(true, "7025", uniqueRequestId));
      });
  }
export const postWorkItemListAction :any =(dispatch: any,data:any, callback: any,)=>{
  dispatch(commonActions.setLoader(true));
  let url = `${getApiUrl("workItems", "getWorkItemList")}`;
  axios
    .post(url,data)
    .then((response) => {
      if (!response?.data?.status) {
        dispatch(commonActions.setOverlayLoader(false));
      }
      const uniqueRequestId = getApiUniqueRequestId(url);
      if (response.data.status) {
        callback(response.data.content);
        dispatch(SetWorkItemListData(response.data.content));
        dispatch(commonActions.setLoader(false));
      } else {
        // Handle error case
        dispatch(SetWorkItemListData({hasError : true}));
        dispatch(commonActions.setLoader(false));
        dispatch(commonActions.setMessage(true, response.data.message, uniqueRequestId));
      }
    })
    .catch((err) => {
      dispatch(commonActions.setOverlayLoader(false));        
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setLoader(false));
      dispatch(commonActions.setMessage(true, "7025", uniqueRequestId));
    });
}
export const getDraftsListAction: any = async (dispatch: any, data: any, isDetails: boolean = false, callBack?:any) => {
  dispatch(commonActions.setLoader(true));
  const url = isDetails ? getApiUrl("workItemAdmin", "getDraftDetailAction") : getApiUrl("workItems", "getDraftsList");
  axios
      .post(url,data)
      .then((response) => {
        if (!response?.data?.status) {
          dispatch(commonActions.setOverlayLoader(false));
        }
        const uniqueRequestId = getApiUniqueRequestId(url);
        if (response.data.status) {
          if (isDetails){
            dispatch(SetDTNDetailData(response.data.content));
            callBack(response.data.content);
            dispatch(commonActions.setLoader(false));
          }
          else if (data.RecordType === 1) {
            dispatch(SetDraftsListData(response.data.content));
            callBack(response.data.content);
            dispatch(commonActions.setLoader(false));
          }
           else if (data.RecordType === 2) {
            dispatch(SetBallotHistoryData(response.data.content));
            callBack(response.data.content);
            dispatch(commonActions.setLoader(false));
          }
        } else {
          // Handle error case
          if (isDetails)
            dispatch(SetDTNDetailData({hasError : true}));
          else
            dispatch(SetDraftsListData({hasError : true}));
          dispatch(commonActions.setMessage(true, response.data.message, uniqueRequestId));
        }
      })
      .catch((err) => {
        dispatch(commonActions.setOverlayLoader(false));        
        const uniqueRequestId = getApiUniqueRequestId(url);
        dispatch(commonActions.setMessage(true, "7025", uniqueRequestId));
      });
}
export const getWorkItemDetailAction :any =(dispatch: any,workItemNumber: string)=>{
  dispatch(commonActions.setLoader(true));
  let url = `${getApiUrl("documents", "getWorkDetailList")}${workItemNumber}`;  
  axios
    .get(url)
    .then((response) => {
      if (!response?.data?.content) {
        dispatch(commonActions.setOverlayLoader(false));
      }
      const uniqueRequestId = getApiUniqueRequestId(url);
      if (response.data.content && response.data.content.WorkItemId) {
        dispatch(SetWorkItemDetailData(response.data.content));
        dispatch(commonActions.setOverlayLoader(false));
        dispatch(commonActions.setLoader(false));
      } else {
        dispatch(commonActions.setLoader(false));
        dispatch(commonActions.setminiLoader(false));
        dispatch(commonActions.setOverlayLoader(false));
        dispatch(SetWorkItemListData({hasError : true}));
        dispatch(commonActions.setMessage(true, response.data.message, uniqueRequestId));
      }
    })
    .catch((err) => {
      dispatch(commonActions.setOverlayLoader(false));        
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setLoader(false));
      dispatch(commonActions.setOverlayLoader(false));
      dispatch(commonActions.setMessage(true, "7025", uniqueRequestId));
    });
}
export const putCollaborationWorkItemAction = (req, dispatch, callback) => {
  let collabResponse = { status: false, apiTime: 0 }
  let startTime = performance.now();
  let endTime = performance.now();
  const timer = setTimeout(() => {
     endTime = performance.now();
     collabResponse.apiTime = endTime - startTime;
     callback(collabResponse);
 }, 10000);

  axios.defaults.withCredentials = true;
  const url = process.env.REACT_APP_SPECBUILDER_CONNECT_HOST;
  axios.post(`${url}account/switch?accountId=${process.env.REACT_APP_SPECBUILDER_ACCOUNT_ID}`, '', req.OKTA_Token)
     .then(response => {
        clearTimeout(timer);
        axios.defaults.withCredentials = true;
        req.collabWorkItemInfo.inlineEditingForDraft =  false;
        axios.put(`${url}groups/work-item?accountID=${process.env.REACT_APP_SPECBUILDER_ACCOUNT_ID}`, req.collabWorkItemInfo, req.OKTA_Token)
           .then((specResponse) => {
              clearTimeout(timer);
              dispatch(commonActions.setLoader(false));
              collabResponse.status = true;
              callback(collabResponse);
           })
           .catch((error) => {
              dispatch(commonActions.setOverlayLoader(false));
              clearTimeout(timer);
              callback(collabResponse);
              dispatch(commonActions.setLoader(false));
           });
     })
     .catch((error) => {
        dispatch(commonActions.setOverlayLoader(false));
        clearTimeout(timer);
        callback(collabResponse);
        dispatch(commonActions.setLoader(false));
     });
}

export const updateWorkItemDetailsAction = (
  dispatch: any,
  data: any,
  callback: any
): void => {
  const url = getApiUrl('workItemAdmin', 'updateWorkItemDetails');
  const wkNumber = removeLeadingZeroes(data.WorkItemNumber);
  dispatch(commonActions.setOverlayLoader(true));
  dispatch(commonActions.setLoader(true));
  axios
    .put(url, data)
    .then((response: any) => {
      if (!response?.data?.status) {
        dispatch(commonActions.setOverlayLoader(false));
      }
      const { status, content, message } = response.data;

      if (status) {
        if (
          content &&
          content.collabWorkItemInfo &&
          content.OKTA_Token &&
          content.OKTA_Token.headers
        ) {
          putCollaborationWorkItemAction(content, dispatch, (collabRes: { status: boolean }) => {
            dispatch(commonActions.setLoader(false));

            if (!collabRes.status) {
              postCollabApiFailureEmail(
                content.collabWorkItemInfo!.metaData.id,
                1
              );
              setCollabAPIFailedPopup(getMessage(messages, '9175.text'), dispatch);
              postWorkItemAuditLog(
                content.collabWorkItemInfo!.metaData.id,
                AuditLogTypeEnum.collabEditApiFailed
              );
            } else {
              dispatch(commonActions.showSuccessToastMesage(true, "", `Work Item ${wkNumber} successfully updated!`));
            }
          });
        } else {
          dispatch(commonActions.setOverlayLoader(false));
          dispatch(commonActions.setLoader(false));
          dispatch(commonActions.showSuccessToastMesage(true, "", `Work Item ${wkNumber} successfully updated!`));
        }
         const uniqueRequestId = getApiUniqueRequestId(url);
        callback(status, uniqueRequestId);
      } else {
        dispatch(commonActions.setOverlayLoader(false));
        dispatch(commonActions.setLoader(false));
        dispatch(commonActions.setMessage(true, message || '')); // Default to empty string if message is undefined
      }
    })
    .catch((err) => {
      dispatch(commonActions.setOverlayLoader(false));
      dispatch(commonActions.setLoader(false));
      dispatch(commonActions.setMessage(true, '9077'));
    });
};
export const getStandardTypeListAction = (dispatch,callback) => {
  const url = getApiUrl('documents', 'getStandardTypeList');
  dispatch(commonActions.setLoader(true));
  axios.get(url)
     .then((response) => {
      if (!response?.data?.content) {
        dispatch(commonActions.setOverlayLoader(false));
      }
      dispatch(commonActions.setLoader(false));
      callback(response.data.content)
     })
     .catch((err) => {
        dispatch(commonActions.setOverlayLoader(false));
        dispatch(commonActions.setMessage(true, '9076'));
     })
}

export const getAllStandardTypeListAction = (dispatch,callback) => {
  const url = getApiUrl('workItems', 'getAllStandardTypesAction');
  dispatch(commonActions.setLoader(true));
  axios.get(url)
     .then((response) => {
      dispatch(commonActions.setLoader(false));
      callback(response.data)
     })
     .catch((err) => {
        dispatch(commonActions.setOverlayLoader(false));
        dispatch(commonActions.setMessage(true, '9076'));
     })
}

export const getReplacementDesignations =(dispatch: any, data: any, callback:any)=>{
  const url = getApiUrl('workItems', 'getReplacementDesignations');
  dispatch(commonActions.setLoader(true));
  axios.post(url, data)
     .then((response) => {
      dispatch(commonActions.setLoader(false));
      callback(response.data)
     })
     .catch((err) => {
        dispatch(commonActions.setOverlayLoader(false));
        dispatch(commonActions.setMessage(true, '9191'));
     })
}

export const updateWITN = (dispatch: any, data: any, callback:any)=>{
   const url = getApiUrl('workItems', 'editWorkItemTracking');
  dispatch(commonActions.setLoader(true));
  axios.put(url, data)
     .then((response) => {
      if (!response?.data?.status) {
        dispatch(commonActions.setOverlayLoader(false));
      }
      dispatch(commonActions.setLoader(false));
      if(response.data.status){
       callback(response.data)
      }else{
        dispatch(commonActions.setMessage(true, '9190'));
      }
     })
     .catch((err) => {
        dispatch(commonActions.setOverlayLoader(false));
        dispatch(commonActions.setMessage(true, '9190'));
     })
}
export const deleteWorkItemAction :any =(dispatch: any, data:any, isAdminWI: boolean, callback: any)=>{
  dispatch(commonActions.setOverlayLoader(true));
  dispatch(commonActions.setLoader(true));
  const encodedPayload = encodeURIComponent(JSON.stringify(data));
  const url = isAdminWI ? `${getApiUrl("workItemAdmin", "deleteADWorkItem")}?payload=${encodedPayload}` : `${getApiUrl("workItemAdmin", "deleteWorkItem")}?payload=${encodedPayload}`;
  const wkNumber = removeLeadingZeroes(data.WorkItemNumber);
  axios
    .delete(url,data)
    .then((response) => {
      if (!response?.data?.status) {
        dispatch(commonActions.setOverlayLoader(false));
      }
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setLoader(false));
      if (response.data.status) {
        // Audit log capture if colab API failed to restore
        if (isAdminWI) {
          callback(response.data.status, uniqueRequestId);
          return;
        }
        if (Number(response.data.message) === 1018) {
          postCollabApiFailureEmail(data.WorkItemNumber.toLowerCase().replace("wk", ""), CollabApiFailureActionEnum.Delete);
          setCollabAPIFailedPopup(getMessage(messages, "1018.text"), dispatch);
          postWorkItemAuditLog(data.WorkItemNumber.toLowerCase().replace("wk", ""), AuditLogTypeEnum.collabDeleteApiFailed);
          dispatch(commonActions.setOverlayLoader(false));
        } else {
          dispatch(commonActions.setOverlayLoader(false));
          dispatch(commonActions.showSuccessToastMesage(true, "", `Work Item ${wkNumber} successfully deleted!`));
        }
        callback(response.data.status, uniqueRequestId);
      } else {
        // Handle error case
        dispatch(commonActions.setOverlayLoader(false));
        dispatch(commonActions.setMessage(true, response.data.message, uniqueRequestId));
        callback(false);
      }
    })
    .catch((err) => {
      dispatch(commonActions.setOverlayLoader(false));        
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setOverlayLoader(false));
      dispatch(commonActions.setLoader(false));
      dispatch(commonActions.setMessage(true, "7025", uniqueRequestId));
    });
}
export const postWorkItemAuditLog = (workitemNumber, logType) => {
  const url = `${getApiUrl('workItemAdmin', 'auditLog')}`;
  let data = {
     WorkItemNumber: workitemNumber,
     LogType: logType
  };
  axios.post(url, data)
     .then((response) => {
        // Todo
     })
     .catch((err) => {
        // Todo
     })
}

export const setCollabAPIFailedPopup = (collabApiErrorMessage, dispatch) => {
  dispatch({ type: _types.SET_COLLAB_API_FAILED, data: collabApiErrorMessage });
}
export const postCollabApiFailureEmail = (workitemNumber, action) => {
  const url = `${getApiUrl('workItemAdmin', 'sendCollabApiFailureEmail')}`;
  let data = {
     WorkItemNumber: `WK${workitemNumber}`,
     Action: action
  };
  axios.post(url, data)
     .then((response) => {
        // Todo
     })
     .catch((err) => {
        // Todo
     })
}

export const getWorkItemAuditLogsAction = (data, dispatch, callback) => {
  const url = getApiUrl('workItemAdmin', 'workItemAuditLogs'); 
  dispatch(commonActions.setLoader(true));
  axios.get(url, { params: { requestData:JSON.stringify(data) } })
     .then((response) => {
      if (!response?.data?.status) {
        dispatch(commonActions.setOverlayLoader(false));
      }
      dispatch(commonActions.setLoader(false));

        if (response.data.status) {
           callback(response.data.content);
        } else {
           // Handle error case
           dispatch(commonActions.setMessage(true, response.data.message));
           callback(false);
        }
     })
     .catch((err) => {
        dispatch(commonActions.setOverlayLoader(false));
        callback(false);
        dispatch(commonActions.setLoader(false));
        dispatch(commonActions.setMessage(true, '3000'));
     });
}

export const getWITNAuditLogsAction = (data, dispatch, callback) => {
  const url = getApiUrl('workItemAdmin', 'witnAuditLogs'); 
  dispatch(commonActions.setLoader(true));
  axios.get(url, { params: { requestData:JSON.stringify(data) } })
     .then((response) => {
      if (!response?.data?.status) {
        dispatch(commonActions.setOverlayLoader(false));
      }
      dispatch(commonActions.setLoader(false));

        if (response.data.status) {
           callback(response.data.content);
        } else {
           // Handle error case
           dispatch(commonActions.setMessage(true, response.data.message));
           callback(false);
        }
     })
     .catch((err) => {
        dispatch(commonActions.setOverlayLoader(false));
        callback(false);
        dispatch(commonActions.setLoader(false));
        dispatch(commonActions.setMessage(true, '3000'));
     });
}
export const getMemberListAction = (mainCommitteeId, dispatch, callback) => {
  const url = `${getApiUrl('workItemAdmin', 'getMemberList')}${mainCommitteeId}`;
  dispatch(commonActions.setLoader(true));
  axios.get(url)
     .then(response => {
        if (!response?.data?.status) {
          dispatch(commonActions.setOverlayLoader(false));
        }
        dispatch(commonActions.setLoader(false));
        if (response.data.status) {
          callback(response.data)
        }
     })
     .catch((err) => {
        dispatch(commonActions.setOverlayLoader(false));
        dispatch(commonActions.setLoader(false));
        dispatch(commonActions.setMessage(true, '9109'));
     });
}
export const getDraftBallotHistoryAction: any = (dispatch: any, data: any, callback: any) => {
  dispatch(commonActions.setLoader(true));
  const url = getApiUrl("workItems", "getDraftBallotHistory");
  axios
    .post(url, data)
    .then((response: any) => {
      if (!response?.data?.status) {
        dispatch(commonActions.setOverlayLoader(false));
      }
      if (response && response.data.status) {
        callback(response.data.content);
        dispatch(commonActions.setLoader(false));
      } else {
        callback({});
        dispatch(commonActions.setLoader(false));
      }
    })
    .catch((err) => {
      dispatch(commonActions.setOverlayLoader(false));
      callback({});
      dispatch(commonActions.setLoader(false));
    });
};
const restoreCollaborationWorkItemAction = (req, dispatch, callback) => {

  let collabResponse = { status: false, apiTime: 0 }
  let startTime = performance.now();
  let endTime = performance.now();
  const timer = setTimeout(() => {
     endTime = performance.now();
     collabResponse.apiTime = endTime - startTime;
     callback(collabResponse);
 }, 10000);

  const url = process.env.REACT_APP_SPECBUILDER_CONNECT_HOST
  axios.defaults.withCredentials = true;
  axios.post(`${url}account/switch?accountId=${process.env.REACT_APP_SPECBUILDER_ACCOUNT_ID}`, '', req.OKTA_Token)
     .then(response => {
        clearTimeout(timer);
        axios.get(req.Collab_Url, req.OKTA_Token)
           .then(collabRes => {
              clearTimeout(timer);
              collabResponse.status = true;
              callback(collabResponse);
           })
           .catch((error) => {
              dispatch(commonActions.setOverlayLoader(false));
              clearTimeout(timer);
              callback(collabResponse);
              dispatch(commonActions.setLoader(false));
           });
     })
     .catch((error) => {
        dispatch(commonActions.setOverlayLoader(false));
        clearTimeout(timer);
        callback(collabResponse);
        dispatch(commonActions.setLoader(false));
     });

}
export const putRestoreWorkItemAction = (dispatch, req, callback) => {
  const url = `${getApiUrl('workItemAdmin', 'restoreWorkItem')}${req.WorkItemId}?WorkItemNumber=${req.WorkItemNumber}&memberId=${req.CreatedBy}&IsOnlineCollaboration=${req.IsOnlineCollaboration}&RestoreWithCollaboration=${req.RestoreWithCollaboration}&collabId=${req.collabId}`;
  dispatch(commonActions.setLoader(true));
  const wkNumber = removeLeadingZeroes(req.WorkItemNumber);
  axios.put(url, req)
     .then(response => {
        if (!response?.data?.status) {
          dispatch(commonActions.setOverlayLoader(false));
        }
        const uniqueRequestId = getApiUniqueRequestId(url);
        if (response.data.status) {
           if (response.data.content && response.data.content.OKTA_Token && response.data.content.Collab_Url) {
              restoreCollaborationWorkItemAction(response.data.content, dispatch, (collabRes) => {
                 if (response.data.content.collabWorkItemInfo && collabRes.status) {
                    putCollaborationWorkItemAction(response.data.content, dispatch, (updateCollabRes) => {
                       dispatch(commonActions.setLoader(false));
                       // Audit log capture if colab API failed to restore
                       if (!updateCollabRes.status) {
                          postCollabApiFailureEmail(req.WorkItemNumber.toLowerCase().replace('wk', ''), CollabApiFailureActionEnum.Restore);
                          setCollabAPIFailedPopup(getMessage(messages, '9174.text'), dispatch);
                          postWorkItemAuditLog(req.WorkItemNumber.toLowerCase().replace('wk', ''), AuditLogTypeEnum.collabRecoverApiFailed);
                       } else{
                          dispatch(commonActions.showSuccessToastMesage(true, "", `Work Item ${wkNumber} successfully restored!`));
                       }
                       callback(response.data.status, uniqueRequestId);
                    })
                 } else {
                    dispatch(commonActions.setLoader(false));
                    // Audit log capture if colab API failed to restore
                    if (!collabRes.status) {
                       postCollabApiFailureEmail(req.WorkItemNumber.toLowerCase().replace('wk', ''), CollabApiFailureActionEnum.Restore);
                       setCollabAPIFailedPopup(getMessage(messages, '9174.text'), dispatch);
                       postWorkItemAuditLog(req.WorkItemNumber.toLowerCase().replace('wk', ''), AuditLogTypeEnum.collabRecoverApiFailed);
                    } else {
                      dispatch(commonActions.showSuccessToastMesage(true, "", `Work Item ${wkNumber} successfully restored!`));
                    }
                    callback(response.data.status, uniqueRequestId);
                 }
              })
           } else {
              dispatch(commonActions.setLoader(false));
              dispatch(commonActions.showSuccessToastMesage(true, "", `Work Item ${wkNumber} successfully restored!`));                          
              callback(response.data.status,uniqueRequestId);
           }
        } else {
           dispatch(commonActions.setLoader(false));
           // Handle error case
           dispatch(commonActions.setMessage(true, response.data.message));
           callback(false, uniqueRequestId);
        }
     })
}
export const deleteWITNAction :any =(dispatch: any, data:any, callback: any)=>{
  dispatch(commonActions.setLoader(true));
  let url = getApiUrl("workItems", "deleteWITN");
  axios
    .delete(url,{data: data})
    .then((response) => {
      if (!response?.data?.status) {
        dispatch(commonActions.setOverlayLoader(false));
      }
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setLoader(false));
      if (response.data.status) {
        if (response.data?.content?.status) {
          dispatch(commonActions.showSuccessToastMesage(true, "", `Work item tracking number ${response.data?.content?.WorkItemTrackingNumber} successfully deleted!`));
          callback(response.data.status);
        } else {
          dispatch(commonActions.setMessage(true, response.data?.content?.statusCode, uniqueRequestId, response.data?.content?.Message));
          callback(false);
        }
      } else {
        // Handle error case
        dispatch(commonActions.setMessage(true, response.data.message, uniqueRequestId, response.data?.content?.Message));
        callback(false);
      }
    })
    .catch((err) => {
      dispatch(commonActions.setOverlayLoader(false));        
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setLoader(false));
      dispatch(commonActions.setMessage(true, "7025", uniqueRequestId));
    });
}

export const addAdminWorkitemction :any =(data:any,method:string, dispatch: any, callback: any)=>{
  dispatch(commonActions.setLoader(true));
  dispatch(commonActions.setOverlayLoader(true));
  let url = getApiUrl("workItems", "processAdminWorkItem");
  axios[method](url,data)
    .then((response) => {
      if (!response?.data?.status) {
        dispatch(commonActions.setOverlayLoader(false));
      }
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setLoader(false));
      if (response.data.status) {
        const item = response.data?.content;
        const workItemNumber = `${item?.WorkItemCategory}${item?.WorkItemNumber}`;
        data.WorkItemId
        ? dispatch(commonActions.showSuccessToastMesage(true, "", getMessage(messages, '9187.text').replace("@workItemNumber",workItemNumber)))
        : dispatch(commonActions.showSuccessToastMesage(true, "",  getMessage(messages, '9188.text').replace("@workItemNumber",workItemNumber)));
        callback(response.data.status);
      } else {
        // Handle error case
        dispatch(commonActions.setMessage(true, response.data.message, uniqueRequestId));
        callback(false);
        dispatch(commonActions.setOverlayLoader(false));
      }
    })
    .catch((err) => {
      dispatch(commonActions.setOverlayLoader(false));        
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setLoader(false));
      dispatch(commonActions.setOverlayLoader(false));
      dispatch(commonActions.setMessage(true, "7025", uniqueRequestId));
    });
}

export const getProcessWorkItemAction: any = (dispatch: any, data?: any, isDetails: boolean = false, callBack?:any) => {
  dispatch(commonActions.setLoader(true));
  const url = getApiUrl("workItems", "getProcessWorkitem");
  axios
      .post(url,data)
      .then((response) => {
        if (!response?.data?.status) {
          dispatch(commonActions.setOverlayLoader(false));
        }
        const uniqueRequestId = getApiUniqueRequestId(url);
        if (response.data.status) {
            dispatch(commonActions.setLoader(false));
        } else {
          dispatch(commonActions.setLoader(false));
          dispatch(commonActions.setMessage(true, "7025", uniqueRequestId));
        }
      })
      .catch((err) => {
        dispatch(commonActions.setOverlayLoader(false));        
        const uniqueRequestId = getApiUniqueRequestId(url);
        dispatch(commonActions.setLoader(false));
        dispatch(commonActions.setMessage(true, "7025", uniqueRequestId));
      });
}

export const getWorkItemStatusAction :any =(dispatch: any, callBack: any)=>{
  dispatch(commonActions.setLoader(true));
  let url = `${getApiUrl("workItems", "getWorkItemStatus")}`;  
  axios
    .get(url)
    .then((response) => {
      if (!response?.data?.content) {
        dispatch(commonActions.setOverlayLoader(false));
      }
      const uniqueRequestId = getApiUniqueRequestId(url);
      if (response.data.content) {
        callBack(response.data.content)
        dispatch(commonActions.setLoader(false));
      } else {
        dispatch(commonActions.setMessage(true, response.data.message, uniqueRequestId));
      }
    })
    .catch((err) => {
      dispatch(commonActions.setOverlayLoader(false));        
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setLoader(false));
      dispatch(commonActions.setMessage(true, "7025", uniqueRequestId));
    });
}
export const getWorkItemTypesAction :any =(dispatch: any,callBack:any)=>{
  dispatch(commonActions.setLoader(true));
  let url = `${getApiUrl("workItems", "getWorkItemType")}`;  
  axios
    .get(url)
    .then((response) => {
      if (!response?.data?.content) {
        dispatch(commonActions.setOverlayLoader(false));
      }
      const uniqueRequestId = getApiUniqueRequestId(url);
      if (response.data.content) {
        callBack(response.data.content)
        dispatch(commonActions.setLoader(false));
      } else {
        dispatch(commonActions.setMessage(true, response.data.message, uniqueRequestId));
      }
    })
    .catch((err) => {
      dispatch(commonActions.setOverlayLoader(false));        
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setLoader(false));
      dispatch(commonActions.setMessage(true, "7025", uniqueRequestId));
    });
}
export const getItemDocumentInfoAction: any = (dispatch: any, data, callBack: any, displayFileSize: boolean = true) => {
  dispatch(commonActions.setLoader(true));
  commonActions.ValidateOktaToken((oktaResponse: any) => {
    let oktaToken = oktaResponse;
    dispatch(commonActions.setLoader(true));
    let url = displayFileSize ? getApiUrl("openAPI", "documentInfo", true) : getApiUrl("openAPI", "documentInfoV1_1", true);
    oktaToken["keep-body-params"] = "false";
    axios
      .post(url, data, {
        headers: { ...oktaToken },
      })
      .then((response) => {
        if (!response?.data?.ResponseStatus) {
          dispatch(commonActions.setOverlayLoader(false));
        }
        const uniqueRequestId = getApiUniqueRequestId(url);
        if (response.data.ResponseData) {
          callBack(response.data.ResponseData, response.data.ResponseStatus)
          dispatch(commonActions.setLoader(false));
        } else {
          dispatch(commonActions.setLoader(false));
          dispatch(commonActions.setMessage(true, response.data.message, uniqueRequestId));
        }
      })
      .catch((err) => {
        dispatch(commonActions.setOverlayLoader(false));
        const uniqueRequestId = getApiUniqueRequestId(url);
        dispatch(commonActions.setLoader(false));
        dispatch(commonActions.setMessage(true, "7025", uniqueRequestId));
      });
  })
}
export const getdownloadDocumentAction: any = (dispatch: any, url: string,data:any, callback: any) => {
   commonActions.ValidateOktaToken((oktaResponse: any) => {
     let oktaToken = oktaResponse;
     dispatch(commonActions.setLoader(true));
  axios
    .post(url,data, {
      headers: {...oktaToken},
    })
    .then((response: any) => {
      if (!response?.status) {
        dispatch(commonActions.setOverlayLoader(false));
      }
      if (response.status) {
        callback(response.data);
        dispatch(commonActions.setLoader(false));
      } else {
        callback({});
        dispatch(commonActions.setLoader(false));
      }
    })
    .catch((err) => {
      dispatch(commonActions.setOverlayLoader(false));
      callback({});
      dispatch(commonActions.setLoader(false));
    });
   })  
};
export const getWorkItemsAction :any =(req:string,dispatch: any,callBack:any)=>{
  dispatch(commonActions.setLoader(true));
  let url = `${getApiUrl("workItems", "getWorkItems")}`;  
  axios
    .post(url,req)
    .then((response) => {
      if (!response?.data?.content) {
        dispatch(commonActions.setOverlayLoader(false));
      }
      const uniqueRequestId = getApiUniqueRequestId(url);
      if (response.data.content) {
        callBack(response.data.content) 
        dispatch(commonActions.setLoader(false));
      } else {
        dispatch(commonActions.setMessage(true, response.data.message, uniqueRequestId));
      }
    })
    .catch((err) => {
      dispatch(commonActions.setOverlayLoader(false));        
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setLoader(false));
      dispatch(commonActions.setMessage(true, "7025", uniqueRequestId));
    });
}

export const getWorkItemsExportAction :any =(dispatch: any,data:any, callback: any,)=>{
    dispatch(commonActions.setLoader(true));
    const encodedPayload = encodeURIComponent(JSON.stringify(data));
    let url = `${getApiUrl("documents", "getWorkItemList")}?payload=${encodedPayload}`;
    axios
      .get(url)
      .then((response) => {
        if (!response?.data?.status) {
          dispatch(commonActions.setOverlayLoader(false));
        }
        const uniqueRequestId = getApiUniqueRequestId(url);
        if (response.data.status) {
          callback(response.data.content);          
          dispatch(commonActions.setLoader(false));
        } else {
          // Handle error case
          dispatch(SetWorkItemListData({hasError : true}));
          dispatch(commonActions.setMessage(true, response.data.message, uniqueRequestId));
        }
      })
      .catch((err) => {
        dispatch(commonActions.setOverlayLoader(false));        
        const uniqueRequestId = getApiUniqueRequestId(url);
        dispatch(commonActions.setLoader(false));
        dispatch(commonActions.setMessage(true, "7025", uniqueRequestId));
      });
  };

export const getDraftActionList: any = (dispatch: any, callback: any) => {
dispatch(commonActions.setLoader(true));
   let url = getApiUrl("workItems", "getDraftActionList");
    axios
      .get(url)
      .then((response) => {
        if (!response?.data?.status) {
          dispatch(commonActions.setOverlayLoader(false));
        }
        const uniqueRequestId = getApiUniqueRequestId(url);
        dispatch(commonActions.setLoader(false));
        if (response.data.status) {
          callback(response.data);          
          dispatch(commonActions.setLoader(false));
        } else {
          // Handle error case
          dispatch(SetWorkItemListData({hasError : true}));
          dispatch(commonActions.setMessage(true, response.data.message, uniqueRequestId));
        }
      })
      .catch((err) => {
        dispatch(commonActions.setOverlayLoader(false));        
        const uniqueRequestId = getApiUniqueRequestId(url);
        dispatch(commonActions.setLoader(false));
        dispatch(commonActions.setMessage(true, "7025", uniqueRequestId));
      });
}
export const getWIDetailOnWITN : any = (dispatch: any, witn: string, callback: any)=>{
  dispatch(commonActions.setLoader(true));
   let url = `${getApiUrl("workItemAdmin", "getWIDetailOnWITN")}/${witn.trim()}`;
   axios
      .get(url)
      .then((response) => {
        if (!response?.data?.status) {
          dispatch(commonActions.setOverlayLoader(false));
        }
        const uniqueRequestId = getApiUniqueRequestId(url);
        dispatch(commonActions.setLoader(false));
        if (response.data.status) {
          callback(response.data.content);          
          dispatch(commonActions.setLoader(false));
        } else {
          // Handle error case
          dispatch(SetWorkItemListData({hasError : true}));
          dispatch(commonActions.setMessage(true, response.data.message, uniqueRequestId));
        }
      })
      .catch((err) => {
        dispatch(commonActions.setOverlayLoader(false));        
        const uniqueRequestId = getApiUniqueRequestId(url);
        dispatch(commonActions.setLoader(false));
        dispatch(commonActions.setMessage(true, "7025", uniqueRequestId));
      });
}
export const updateWITNAdminHoldAction: any = (data: any, dispatch: any, callback: (response: any) => void) => {
  dispatch(commonActions.setLoader(true));
  let url = getApiUrl("workItems", "updateWITNAdminHold");
  axios
    .post(url, data)
    .then((response) => {
      if (!response?.data?.status) {
        dispatch(commonActions.setOverlayLoader(false));
      }
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setLoader(false));
      if (response.data.content && response.data.status) {
        callback(response.data.content);
      } else {
        callback({});
      }
    })
    .catch((err) => {
      dispatch(commonActions.setOverlayLoader(false));
      dispatch(commonActions.setLoader(false));
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setMessage(true, "1024", uniqueRequestId));
    });
};
export const getCommitteeOfficerTitleAction: any = (data: Number[], dispatch: any, callback: (response: any) => void) => {
  dispatch(commonActions.setLoader(true));
   const url = getApiUrl("workItems", "getCommitteeOfficerTitle");
  axios
    .post(url, data)
    .then((response) => {
      if (!response?.data?.status) {
        dispatch(commonActions.setOverlayLoader(false));
      }
     
      dispatch(commonActions.setLoader(false));
      if (response.data.content && response.data.status) {
        callback(response.data.content);
      } else {
        callback({});
      }
    })
    .catch((err) => {
      dispatch(commonActions.setOverlayLoader(false));
      dispatch(commonActions.setLoader(false));
      const uniqueRequestId = getApiUniqueRequestId(url);
      dispatch(commonActions.setMessage(true, "1024", uniqueRequestId));
    });
};
